// AI-CONTEXT: See docs/features/msi-effect-radar-chart.md

/**
 * Tooltip content for the MSI-effect radar chart: the hovered question (angle-axis
 * label) followed by each meetmoment's score for that question. Styled via CSS
 * (no inline styles); the moment name labels each row, so no per-series colour is
 * needed. Mirrors the MatrixLineTooltip pattern.
 *
 * @param {object} props
 * @param {boolean} [props.active] - recharts: whether the tooltip is active.
 * @param {Array<{name?: string, dataKey?: string, value?: number}>} [props.payload] - recharts hovered series (one per moment).
 * @param {string} [props.label] - recharts: the angle-axis value (the question).
 * @returns {JSX.Element|null}
 */
const MatrixRadarTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null

  return (
    <div className="matrix-radar-tooltip">
      <div className="matrix-radar-tooltip-label">{label}</div>
      {payload.map((entry, index) => (
        <div key={`tt-${index}`} className="matrix-radar-tooltip-row">
          <span>{entry.name || entry.dataKey}</span>: {typeof entry.value === 'number' ? entry.value.toFixed(1) : '—'}
        </div>
      ))}
    </div>
  )
}

export default MatrixRadarTooltip
